// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "e7ad493c74f4a9fc8295fbe935b3d9707160574d/static/css/" + chunkId + "." + "0b63a1be" + ".chunk.css";
};